module.exports = __webpack_public_path__ + "static/img/logo.e89470c.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo.svg
// module id = 210
// module chunks = 56